import axios from "axios";
import {
  EBARIMT_LOADING,
  CREATE_EBARIMT,
  CREATE_EBARIMT_ERROR,
  DELETE_EBARIMT,
  SEND_EBARIMT,
} from "./types";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";

const handleAuthError = (err, dispatch) => {
  if (
    err.response &&
    err.response.status === 401 &&
    err.response.data.msg === "Token is not valid"
  ) {
    window.localStorage.clear("x-auth-token");
    toastr.error("Session expired");
    dispatch(logout());
  }
};

// Create ebarimt receipt
export const createEbarimt = (formData) => async (dispatch) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    dispatch({ type: EBARIMT_LOADING });
    const body = JSON.stringify(formData);
    const res = await axios.post("/api/payment/ebarimt", body, config);
    dispatch({ type: CREATE_EBARIMT, payload: res.data });
    toastr.success("E-barimt created successfully");
  } catch (err) {
    handleAuthError(err, dispatch);
    dispatch({ type: CREATE_EBARIMT_ERROR });
    const errors = err.response && err.response.data.errors;
    if (errors) {
      errors.forEach((error) => toastr.error(error.msg));
    } else {
      toastr.error("Failed to create e-barimt");
    }
  }
};

// Delete ebarimt receipt (using POST)
export const deleteEbarimt = (id) => async (dispatch) => {
  try {
    await axios.post(
      "/api/payment/ebarimt-delete",
      { id }, // ✅ body
      {
        headers: { "Content-Type": "application/json" }, // ✅ config
      }
    );

    dispatch({ type: DELETE_EBARIMT });
    toastr.success("E-barimt deleted successfully");
  } catch (err) {
    handleAuthError(err, dispatch);
    toastr.error("Failed to delete e-barimt");
  }
};

// Send ebarimt data
export const sendEbarimt = () => async (dispatch) => {
  try {
    await axios.get("/api/payment/send-ebarimt");
    dispatch({ type: SEND_EBARIMT });
    toastr.success("E-barimt data sent successfully");
  } catch (err) {
    handleAuthError(err, dispatch);
    toastr.error("Failed to send e-barimt data");
  }
};
